import { CHECKOUT_THANKYOU_PAGE, REPAYMENT_THANKYOU_PAGE } from '@const/index';
import {
  IOnlineCheckoutTransactionDataOptionUrl,
  TPaymentProvider,
  TPaymentRedirectType,
} from '@features/checkout/typescript';
import { TIcon } from '@components/icons/typescript';
import theme from '@styles/theme';
import getOffer from '@utils/getOffer';
import { OFFER_TO_COUNTRY_MAP, OFFER_TO_REGION_MAP } from '@config/index';
import getPublicEnv from '@utils/getPublicEnv';

export const fillArrayWithNumbers = (arrLength) => [...Array(arrLength)].map((_, i) => i + 1);

export const getPaymentRedirectURI = (
  locale: string,
  type: TPaymentRedirectType,
  provider: TPaymentProvider,
  isRepayment = false,
  orderId = '',
): IOnlineCheckoutTransactionDataOptionUrl => {
  let targetUrl = CHECKOUT_THANKYOU_PAGE;
  if (isRepayment && orderId) {
    targetUrl = REPAYMENT_THANKYOU_PAGE.replace('[orderId]', orderId);
  }

  return {
    url: `${getPublicEnv('NEXT_PUBLIC_HOST')}/${locale}/${targetUrl}`,
    parameters: {
      type,
      provider,
    },
  };
};

export const getLanguage = (locale: string | undefined): string => locale?.substr(0, 2).toLocaleLowerCase() || 'es';

export const getRegion = (cateType?: 'lowercase' | 'uppercase'): string => {
  const [offer] = getOffer();
  let region = OFFER_TO_REGION_MAP[offer].toUpperCase();

  if (cateType === 'lowercase') region = region.toLowerCase();

  return region;
};

export const getRegionDefaultLang = (cateType?: 'lowercase' | 'uppercase'): string => {
  const [offer] = getOffer();
  let region = OFFER_TO_COUNTRY_MAP[offer].toUpperCase();

  if (cateType === 'lowercase') region = region.toLowerCase();

  return region;
};

export const removeConfiguratorScripts = () => {
  const mainScriptsArray = [...document.head.querySelectorAll('[data-source="configuratorSource"]')];
  mainScriptsArray.forEach((script) => {
    document.head.removeChild(script);
  });

  const scriptsArray = [...document.head.querySelectorAll('script')];
  scriptsArray.forEach((script) => {
    const scriptSource = script.src;
    if (
      scriptSource.startsWith('https://code.jquery.com') ||
      scriptSource.startsWith('https://cdnjs.cloudflare.com') ||
      scriptSource.startsWith('https://unpkg.com') ||
      scriptSource.startsWith('https://ajax.googleapis.com') ||
      scriptSource.startsWith('https://maxcdn.bootstrapcdn.com') ||
      (scriptSource.startsWith('https://') &&
        (scriptSource.includes('simple.vox.pl') || scriptSource.includes('basic-staging'))) ||
      scriptSource.includes('basic.vox.ltd')
    ) {
      document.head.removeChild(script);
    }
  });

  const stylesArray = [...document.head.querySelectorAll('link')];
  stylesArray.forEach((link) => {
    const styleSource = link.href;
    if (
      styleSource.startsWith('https://netdna.bootstrapcdn.com') ||
      styleSource.startsWith('https://use.fontawesome.com') ||
      (styleSource.startsWith('https://') &&
        (styleSource.includes('simple.vox.pl') || styleSource.includes('basic-staging'))) ||
      styleSource.includes('basic.vox.ltd')
    ) {
      document.head.removeChild(link);
    }
  });

  // TODO: move style removal to frontConfigurator
  if (getPublicEnv('NEXT_PUBLIC_USE_NEW_FRONT_CONFIGURATOR') !== 'true') {
    const styledComponentsStyle = [...document.head.querySelectorAll('[data-styled]')];
    styledComponentsStyle.forEach((style) => {
      document.head.removeChild(style);
    });
  }
};

export const firstUppercase = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const parseIconName = (str: string): TIcon =>
  str
    .split('_')
    .map((v) => v.charAt(0).toUpperCase() + v.slice(1))
    .join('') as TIcon;

export const getSizesString = (valuesArray: string[]) => {
  const { breakpoints } = theme;
  const viewBreakpoints: number[] = [];

  breakpoints.forEach((breakpoint) => viewBreakpoints.push(parseInt(breakpoint.replace('px', ''), 10)));

  const [_, ...rest] = valuesArray;

  let sizesString = rest.length > 1 ? valuesArray[valuesArray.length - 1] : valuesArray[0];

  rest.forEach((value, index) => {
    if (!index) {
      sizesString = `(max-width: ${viewBreakpoints[index]}px) ${value}, ${sizesString}`;
    } else {
      sizesString = `(min-width: ${viewBreakpoints[index - 1] + 1}px) and (max-width: ${
        viewBreakpoints[index]
      }px) ${value}, ${sizesString}`;
    }
  });

  return sizesString;
};
